import { ConfigProvider as AntdConfigProvider, type ConfigProviderProps } from 'antd';
import { createContext, useMemo } from 'react';
import { ANTD_THEME } from '../antd-theme';
import { mergeTheme } from './merge-theme';
export type { ConfigProviderProps } from 'antd';

export const ProtectorConfigProviderContext = createContext(false);

export const ConfigProvider = ({ children, ...props }: ConfigProviderProps) => {
  const theme = useMemo(() => mergeTheme(ANTD_THEME, props.theme), [props.theme]);

  return (
    <ProtectorConfigProviderContext.Provider value={true}>
      <AntdConfigProvider {...props} theme={theme}>
        {children}
      </AntdConfigProvider>
    </ProtectorConfigProviderContext.Provider>
  );
};
